import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { CookieService } from 'ngx-cookie-service';
import { ReflexEnvironment as ENV } from '@smartsoftware/reflex-core';

@Component({
	templateUrl: './view.html',
	styleUrls: ['./view.scss'],
})
export class EntraView implements OnInit {
	constructor(
		protected auth: OidcSecurityService,
		private cookieService: CookieService
	) {
	}

	private saml_username = '';
	private saml_client = '';
	private saml_attemptId = '';
	private saml_error = '';
	private azureClient : any;

	private login_hint = 'from=Azure Entra';

	ngOnInit() {
		if(this.cookieService.get('saml_username')) {
			this.saml_username = this.cookieService.get('saml_username');
			this.login_hint += ',username=' + this.saml_username;
			this.cookieService.delete('saml_username', '/', '.firstlegal.com');
		}

		if(this.cookieService.get('saml_attemptId')) {
			this.saml_attemptId = this.cookieService.get('saml_attemptId');
			this.login_hint += ',attemptId=' + this.saml_attemptId;
			this.cookieService.delete('saml_attemptId', '/', '.firstlegal.com');
		}

		if(this.cookieService.get('saml_client')) {
			this.saml_client = this.cookieService.get('saml_client');
			this.login_hint += ',client=' + this.saml_client;
			this.cookieService.delete('saml_client', '/', '.firstlegal.com');
			this.azureClient = this.getAzureClient(this.saml_client);
			this.login_hint += ',tenantId=' + this.azureClient.tenantId;
		}

		if(this.cookieService.get('saml_error')) {
			this.saml_error = this.cookieService.get('saml_error');
			this.cookieService.delete('saml_error', '/', '.firstlegal.com');
			let config = this.auth.getConfiguration();
			if(config && config.redirectUrl && config.unauthorizedRoute) {
				window.localStorage.setItem('saml_error', this.saml_error);
				window.location.href = config.redirectUrl + config.unauthorizedRoute;
			}
		}

		if(!this.saml_error && this.saml_username && this.azureClient && this.azureClient.tenantId && this.saml_client && this.saml_attemptId)
			this.auth.authorize(undefined, {
				customParams:{
					'login_hint': this.login_hint
				}
			});
	}

	public getAzureClient(client: string): any {
		let azureClients: Array<any> = ENV.config['Azure'];
		for(let i = 0; i < azureClients.length; i ++){
			if(azureClients[i].client == client) return azureClients[i];
		}
	}
}
